module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 019.0fba9525.jpg";